import type { ReactNode } from 'react';

// Presentation only. Unrecognized canonical formats are retained verbatim, never guessed.

export default function TennisScoreboard({ sideA, sideB, score, winner, label, status, emptyLabel = 'Score not recorded' }: {

  sideA: string[]; sideB: string[]; score?: string | null; winner?: string | null; label?: string; status?: ReactNode; emptyLabel?: string;

}) {

  const parts = score?.trim().split(/[,\s]+/) ?? [];
  const sets = parts.map(part => part.match(/^(\d+)-(\d+)(?:\((\d+)\))?$/) || part.match(/^\[(\d+)-(\d+)\]$/));
  const parsed = sets.length > 0 && sets.every(Boolean);
  return <div className="tk-scoreboard">

    <div className="tk-score-meta"><span>{label}</span>{status}</div>

    {parsed&&<div className="tk-score-side text-text-muted"><span className="text-xs font-normal">Players</span><span className="tk-set-values">{sets.map((_,i)=><span key={i} className="w-[30px] text-center text-[10px] font-normal">{parts[i].startsWith('[')?'TB':`Set ${i+1}`}</span>)}</span></div>}
    {([sideA, sideB] as const).map((names, side) => <div key={side} className="tk-score-side" data-winner={winner === (side === 0 ? 'A' : 'B')}>

      <span>{names.filter(Boolean).map((name, i) => <span key={i} className="block">{name}</span>)}{!names.filter(Boolean).length && 'Player unavailable'}</span>

      <span className="tk-set-values">{parsed && sets.map((set, i) => <b key={i}>{set![side + 1]}{set![3] && Number(set![side+1]) < Number(set![side===0?2:1]) && <sup aria-label={`Tiebreak ${set![3]}`}>{set![3]}</sup>}</b>)}</span>

    </div>)}

    {!parsed && <p className="px-3 py-2 text-xs text-text-muted">{score || emptyLabel}</p>}

  </div>;

}

